<template>
  <div id="pc-app">
    <!-- 路由 -->
    <router-view></router-view>
  </div>
</template>
<script lang="ts" setup>
</script>
